import React from 'react';
import { AppRouter } from './routers/AppRouter';
import { createTheme, ThemeProvider} from '@mui/material';



const theme = createTheme({
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#240090',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        main: '#b388ff',
      },
  
    third: {
      main: '#80cbc4',
    },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
  });

export const EmytoApp = () => {
    return (
        <div>

        <ThemeProvider theme={theme}>
            <AppRouter/>
            
            </ThemeProvider>
        </div>
    )
}
